import { toDollars, toPercent } from "common/utils/formatting";

import { ProductSearchDiscountBadge } from "../types";

type ProductSearchDiscountBadgesProps = {
  discounts: ProductSearchDiscountBadge[];
  styles: Record<string, string>;
};

// Cap the row so an unusually-promoted item can't overflow the card (realistically 1–2 deals).
const MAX_BADGES = 3;

// A percent-based deal reads "25% off"; a flat-dollar deal reads "$10 off". Either way it's a
// non-autoship deal (autoship stays on the price line of the search card).
const badgeLabel = (discount: ProductSearchDiscountBadge): string =>
  discount.percent != null
    ? `${toPercent(String(discount.percent))} off`
    : `${toDollars(discount.savings_amount, { collapseWholeDollars: true })} off`;

/** The default item's sale deals as card badges; renders nothing when the item has none. */
const ProductSearchDiscountBadges = ({ discounts, styles }: ProductSearchDiscountBadgesProps) => {
  if (!discounts.length) {
    return null;
  }
  return (
    <div className={styles.discountRow}>
      {discounts.slice(0, MAX_BADGES).map((discount, index) => {
        // No stable id from the API; index disambiguates otherwise-identical deals.
        const key = `${discount.kind}-${discount.savings_amount}-${discount.percent}-${index}`;
        return (
          <span key={key} className={styles.dealBadge}>
            {badgeLabel(discount)}
          </span>
        );
      })}
    </div>
  );
};

export default ProductSearchDiscountBadges;
